export default function ProductCategories() {
  return (
    <section id="products" className="py-24 bg-gradient-to-b from-white to-amber-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-amber-100 px-4 py-2 rounded-full mb-4">
            <i className="ri-hand-heart-line text-amber-600"></i>
            <span className="text-sm font-semibold text-amber-900">Handcrafted Collections</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Crafted by Our Hands
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Each collection represents a different skill we've mastered in our home workshop
          </p>
        </div>

        {/* Categories Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-product-shop>
          {/* Hand-Turned Items */}
          <div className="group bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100">
            <div className="relative h-80 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=collection-of-beautiful-handcrafted-wooden-turned-pens-and-small-wooden-items-displayed-on-clean-white-surface-with-natural-wood-grain-patterns-visible-warm-studio-lighting-professional-product-photography-shallow-depth-of-field-artisan-craftsmanship-elegant-composition&width=600&height=800&seq=category-turned-items-003&orientation=portrait"
                alt="Hand-turned wooden items"
                className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute top-6 left-6 bg-white/95 backdrop-blur-sm rounded-full p-3 shadow-lg">
                <i className="ri-contrast-drop-2-line text-2xl text-amber-600"></i>
              </div>
            </div>
            <div className="p-8">
              <div className="flex items-center gap-2 mb-3">
                <i className="ri-hand-heart-line text-amber-600"></i>
                <span className="text-xs font-semibold text-amber-600 uppercase tracking-wider">His Craft</span>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">Hand-Turned Items</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Precision-crafted pens, bottle stoppers, and small treasures turned on the lathe with expert hands
              </p>
              <a
                href="https://www.etsy.com/shop/TelloCrafts"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center text-amber-600 font-semibold hover:text-amber-700 transition-colors cursor-pointer"
              >
                View Collection
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
            </div>
          </div>

          {/* Hand-Painted Signs */}
          <div className="group bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100">
            <div className="relative h-80 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=beautiful-hand-painted-wooden-signs-with-elegant-lettering-and-decorative-designs-displayed-on-clean-white-background-rustic-farmhouse-style-warm-natural-wood-tones-professional-product-photography-soft-studio-lighting-artisan-craftsmanship-charming-composition&width=600&height=800&seq=category-painted-signs-003&orientation=portrait"
                alt="Hand-painted wooden signs"
                className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute top-6 left-6 bg-white/95 backdrop-blur-sm rounded-full p-3 shadow-lg">
                <i className="ri-paint-brush-line text-2xl text-amber-600"></i>
              </div>
            </div>
            <div className="p-8">
              <div className="flex items-center gap-2 mb-3">
                <i className="ri-hand-heart-line text-amber-600"></i>
                <span className="text-xs font-semibold text-amber-600 uppercase tracking-wider">Her Craft</span>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">Hand-Painted Signs</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Custom wooden signs painted with love, perfect for adding warmth and personality to any home
              </p>
              <a
                href="https://www.etsy.com/shop/TelloCrafts"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center text-amber-600 font-semibold hover:text-amber-700 transition-colors cursor-pointer"
              >
                View Collection
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
            </div>
          </div>

          {/* Custom Furniture */}
          <div className="group bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100">
            <div className="relative h-80 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=handcrafted-wooden-furniture-pieces-including-small-tables-shelves-and-decorative-items-displayed-in-bright-clean-studio-setting-natural-wood-grain-visible-warm-inviting-atmosphere-professional-product-photography-artisan-quality-craftsmanship-elegant-rustic-style&width=600&height=800&seq=category-furniture-003&orientation=portrait"
                alt="Custom wooden furniture"
                className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute top-6 left-6 bg-white/95 backdrop-blur-sm rounded-full p-3 shadow-lg">
                <i className="ri-home-4-line text-2xl text-amber-600"></i>
              </div>
            </div>
            <div className="p-8">
              <div className="flex items-center gap-2 mb-3">
                <i className="ri-hand-heart-line text-amber-600"></i>
                <span className="text-xs font-semibold text-amber-600 uppercase tracking-wider">Together</span>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">Custom Furniture</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Unique furniture pieces where our combined skills create functional art for your home
              </p>
              <a
                href="#contact"
                className="inline-flex items-center text-amber-600 font-semibold hover:text-amber-700 transition-colors cursor-pointer"
              >
                Request Custom Piece
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-3 bg-white rounded-2xl px-8 py-6 shadow-lg border border-gray-100">
            <img
              src="https://static.readdy.ai/image/9e0ec1f08df5eac0f8e6ee60a23adb36/71c80160d04a459cf0ff28e8673272c6.png"
              alt="Tello Crafts"
              className="h-12 w-auto"
            />
            <div className="text-left">
              <p className="text-sm font-semibold text-gray-900">Every piece is made in our home</p>
              <p className="text-xs text-gray-600">With care, precision, and love</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
